import { Component, ElementRef, ViewChild } from '@angular/core';
import SignaturePad from 'signature_pad';
import { FormControl, FormGroup, Validators } from '@angular/forms'

@Component({
  selector: 'app-signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.scss']
})
export class SignaturePadComponent {
  signatureNeeded!: boolean;
  signaturePad!: SignaturePad;
  @ViewChild('signPadCanvas', {static: true}) canvas!: ElementRef;
  signatureImg!: string;
  
  signature_info: FormGroup = new FormGroup({
    signatory: new FormControl('', Validators.required),
    party: new FormControl('', Validators.required)
  })

  ngAfterViewInit(){
    this.signaturePad = new SignaturePad(this.canvas.nativeElement);
  }

  saveSignature(){
    if(this.signature_info.valid){
      const base64Data = this.signaturePad.toDataURL();
      this.signatureImg = base64Data;
    }
    else{
      console.log('need to add signatory and/or party')
    }


  }

  clear(){
    this.signaturePad.clear();
  }

  getSignatory(){
    return this.signature_info.get('signatory')?.value;
  }

  getParty(){
    return this.signature_info.get('party')?.value;
  }
}
